import { render, staticRenderFns } from "./TemplateButton.vue?vue&type=template&id=e47cb750&"
import script from "./TemplateButton.vue?vue&type=script&lang=js&"
export * from "./TemplateButton.vue?vue&type=script&lang=js&"
import style0 from "./TemplateButton.vue?vue&type=style&index=0&id=e47cb750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports